<template>
  <div
    class="flex flex-wrap items-center pb-10 membership-layout-container"
    :style="[customCss]"
  >
    <div
      class="mr-2"
      v-for="(item, index) of list"
      :key="index"
      @click="
        isNotLast(index, list.length)
          ? !isPreview && item.is_default!==2
            ? activateElement({ e: '', el: item })
            : sendToPath({ 
                name: item.is_default==2?'home':'post', params:item.is_default==2?{}: { id: item.slug } 
                })
          : () => {}
      "
    >
      <div class="space-x-2 breadcrum-text-color">
        <span
          :class="[
            'text-sm',
            isNotLast(index, list.length) ? 'cursor-pointer' : 'active',
          ]"
          >{{ item.is_default==1?courseSettings.title:item.name }}</span
        >
        <span v-if="isNotLast(index, list.length)">
          <i
            class="fas fa-chevron-right text-sm arrow-grey breadcrum-text-color"
          ></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import extractIndexesHelper from '../../../helpers/extractIndexes';

export default {
  name: 'Breadcrumb',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    hierarchy: {
      required: true,
    },
    activeElement: {
      required: true,
    },
    activateElement: {
      type: Function,
      default: () => {},
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    getThemeSettings: {},
    courseSettings:{},
    getHomeMenuData:{}
  },
  computed: {
    customCss() {
      return {
        '--breadcrum-text-color':
          this.themeSettings.body_section.body_content_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
    list() {
      const arr = [];
      const { cIndex, sIndex, pIndex } = extractIndexesHelper(
        this.hierarchy,
        this.activeElement.value.id
      );

      if (cIndex > -1) {
        arr.push(this.hierarchy[cIndex]);
      }

      if (sIndex > -1) {
        arr.push(this.hierarchy[cIndex].children[sIndex]);
      }

      if (pIndex > -1) {
        arr.push(this.hierarchy[cIndex].children[sIndex].children[pIndex]);
      }

      const welcomePage = this.hierarchy.find((el) => el.is_default === 1);
      
      if (welcomePage && !arr.find((el)=>el.is_default==1)) {
        arr.unshift(welcomePage);
      }

      if(this.getHomeMenuData && this.getHomeMenuData.name && this.getHomeMenuData.slug){
        arr.unshift({id:12,name:this.getHomeMenuData.name,slug:this.getHomeMenuData.slug,is_default:2});
      } else{
        arr.unshift({id:12,name:'Home',slug:'home',is_default:2});
      }
      return arr;
    },
  },
  methods: {
    isNotLast(index, length) {
      return index < length - 1;
    },
  },
};
</script>
<style>
.breadcrum-text-color {
  color: var(--breadcrum-text-color);
}
</style>